import { tx } from "@/i18n/tx";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { Eye, EyeOff, ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error(tx("La password deve contenere almeno 8 caratteri.")); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success(tx("Password aggiornata"));
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="anima-backdrop min-h-screen flex items-center justify-center px-7 text-center">
        <div>
          <p className="font-serif text-3xl text-anima-ink mb-3">{tx("Collegamento non valido")}</p>
          <button onClick={() => navigate("/auth?mode=login")} className="rounded-full bg-anima-sagedeep text-anima-ivory px-6 py-3">{tx("Torna all'accesso")}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="anima-backdrop min-h-screen w-full flex justify-center">
      <div className="w-full max-w-md px-7 py-10 flex flex-col min-h-screen justify-center">
        {!done ? (
          <>
            <ShieldCheck size={40} className="text-anima-sagedeep mb-4" />
            <h1 className="font-serif text-4xl text-anima-ink mb-2">{tx("Nuova password")}</h1>
            <p className="text-anima-muted mb-8">{tx("Scegli una password sicura, di almeno 8 caratteri.")}</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="relative">
                <input
                  data-testid="reset-password-input" type={show ? "text" : "password"} value={password}
                  onChange={(e) => setPassword(e.target.value)} required minLength={8}
                  className="w-full rounded-2xl bg-white/60 border border-anima-ink/10 px-4 py-3.5 pr-12 outline-none focus:border-anima-sage"
                  placeholder={tx("Almeno 8 caratteri")}
                />
                <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-anima-muted p-1">
                  {show ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              <button data-testid="reset-submit-btn" disabled={busy} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium disabled:opacity-60">
                {busy ? tx("Un momento...") : tx("Reimposta la password")}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center" data-testid="reset-done">
            <h1 className="font-serif text-3xl text-anima-ink mb-3">{tx("Fatto")}</h1>
            <p className="text-anima-muted mb-8">{tx("La tua password e stata aggiornata. Ora puoi accedere con le nuove credenziali.")}</p>
            <button onClick={() => navigate("/auth?mode=login")} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium">{tx("Accedi")}</button>
          </div>
        )}
      </div>
    </div>
  );
}
